import { render, staticRenderFns } from "./orderRemarkDialog.vue?vue&type=template&id=df64db20&scoped=true"
import script from "./orderRemarkDialog.vue?vue&type=script&lang=js"
export * from "./orderRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./orderRemarkDialog.vue?vue&type=style&index=0&id=df64db20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df64db20",
  null
  
)

export default component.exports